import styled from 'styled-components';

export const Main = styled('main')({
  '&.text': {
    minHeight: '100vh',
    maxWidth: '1400rem',
    padding: '150rem 50rem 200rem 50rem',
    boxSizing: 'border-box',
    margin: '0 auto',
    '@media (max-width: 1200px)': {
      padding: '100rem 40rem 150rem 40rem',
    },
    '@media (max-width: 768px)': {
      padding: '70rem 30rem 100rem 30rem',
    },
  },
});
